<template>
  <div id="app" :class="isContainer()">
    <HeaderAdminWeddbets
      v-if="isHideHeader() && isAdminWeddbetsHeader()"
    />
    <ClienteHeader
      v-else-if="isHideHeader() && isNovoLayoutCliente()"
    />
    <Header v-else-if="isHideHeader()" />
    <div
      :class="{
        adminHeaderConteudo:
          isHideHeader() && isAdminWeddbetsHeader(),
        clienteHeaderConteudo:
          isHideHeader() && isNovoLayoutCliente(),
      }"
    >
      <router-view></router-view>
    </div>
    <div class="notification-container"></div>
  </div>
</template>

<script>
</script>

<script>
import { api } from "@/services/api.js";
import { apiNotification } from "@/services/apiNotification.js";
import Header from "./components/Header";
import HeaderAdminWeddbets from "./components/HeaderAdminWeddbets";
import ClienteHeader from "./cliente/components/ClienteHeader";

var Tawk_API = Tawk_API || {},
  Tawk_LoadStart = new Date();

function showSuccessNotification(title, message, duration = 5000) {
  const container = document.querySelector(".notification-container");

  // Criar elemento de notificação
  const notification = document.createElement("div");
  notification.className = "notification alert alert-success";

  notification.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#28a745" class="notification-icon" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M13.485 1.343a1 1 0 0 1 1.415 1.415l-9 9a1 1 0 0 1-1.415 0l-4-4a1 1 0 0 1 1.415-1.415L5 9.586l8.485-8.485z"/>
    </svg>
    <h3 class="mb-2">${title}</h3>
    <p class="mb-3">${message}</p>
    <button type="button" class="btn btn-success mt-2" onclick="window.location.reload();">OK</button>
    <div class="progress-bar"></div>
  `;

  container.appendChild(notification);

  // Forçar reflow para ativar a animação
  void notification.offsetWidth;

  // Mostrar notificação
  notification.classList.add("show");

  // Barra de progresso (opcional)
  const progressBar = notification.querySelector(".progress-bar");
  progressBar.style.width = "100%";
  progressBar.style.transitionDuration = `${duration}ms`;

  // Remover após a duração
  /*setTimeout(() => {
    notification.classList.remove('show');
    setTimeout(() => {
      notification.remove();
    }, 500); // Tempo para a animação terminar
  }, duration);*/
}

export default {
  name: "App",
  components: { ClienteHeader, Header, HeaderAdminWeddbets },
  data: function () {
    return {
      autenticado: { status: false, _id: "" },
    };
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    isAdminWeddbetsHeader() {
      return (
        this.$site == "Weddbets" &&
        this.$siteAdmin === true &&
        this.$layoutCliente == "WeddbetsNovo"
      );
    },
    isNovoLayoutCliente() {
      return (
        this.$site == "Weddbets" &&
        this.$siteAdmin === false &&
        this.$layoutCliente == "WeddbetsNovo"
      );
    },
    isContainer() {
      var classTexto =
        this.$route.name == "view" ||
        this.$route.name == "view2" ||
        this.$route.name == "view3" ||
        this.$route.name == "transmit" ||
        this.$route.name == "transmit-remote" ||
        this.$site == "7live"
          ? "container-fluid"
          : "container";

      if (this.$site == "Weddbets") {
        classTexto = "container-fluid";
      }

      classTexto += " " + (this.isHideHeader() ? "appHeader" : "");

      classTexto +=
        " " +
        (this.isHideHeader() && this.isAdminWeddbetsHeader()
          ? "appHeaderAdminWeddbets"
          : "");

      classTexto +=
        " " +
        (this.isHideHeader() && this.isNovoLayoutCliente()
          ? "appHeaderClienteNovo"
          : "");

      classTexto += " " + (this.$site == "7live" ? "noMarginTop" : "");

      classTexto +=
        " " +
        (this.$site == "7live" &&
        (this.$route.name == "view" ||
          this.$route.name == "view2" ||
          this.$route.name == "view3")
          ? "noPadding"
          : "");

      return classTexto;
    },
    isAdmin: function () {
      return (
        this.$sessao.usuario &&
        (this.$sessao.usuario.tipoUsuario == "Administrador" ||
          this.$sessao.usuario.tipoUsuario == "Administrador Site")
      );
    },
    isEscondeChat: function () {
      return (
        this.$sessao.usuario &&
        (this.$sessao.usuario.tipoUsuario == "Administrador" ||
          this.$sessao.usuario.tipoUsuario == "Administrador Site" ||
          this.$sessao.usuario.tipoUsuario == "Apresentador")
      );
    },
    isHideHeader() {
      /*if(this.$route.name == null){
        return false;
      }*/

      return (
        this.$route.name !== "view" &&
        this.$route.name !== "view2" &&
        this.$route.name !== "view3" &&
        this.$route.name !== "transmit" &&
        this.$route.name !== "transmit-remote" &&
        this.$route.name !== "sofascore" &&
        this.$route.name !== "recuperar-senha" &&
        this.$route.name !== "login" &&
        this.$route.name !== "cadastro"
      );
    },
    chatTank() {
      let scriptTank = document.createElement("script");
      scriptTank.setAttribute("type", "text/javascript");
      scriptTank.setAttribute(
        "src",
        "https://embed.tawk.to/60637625f7ce1827093586cb/1f228b15d"
      );
      scriptTank.setAttribute("async", true);
      scriptTank.setAttribute("charset", "UTF-8");
      scriptTank.setAttribute("crossorigin", "*");
      document.head.appendChild(scriptTank);

      console.log(Tawk_LoadStart);
    },
    chatWbot() {
      /*
      let scriptWbot = document.createElement("script");
      scriptWbot.setAttribute("type", "text/javascript");
      scriptWbot.setAttribute("src", "https://wbot.chat/index.js");
      scriptWbot.setAttribute("async", true);
      scriptWbot.setAttribute('token','daaeb5b142a176638178c4a6109cb849');
      document.head.appendChild(scriptWbot);
      */
      let scriptJivo = document.createElement("script");
      scriptJivo.setAttribute("src", "//code.jivosite.com/widget/6C1auLy6iE");
      scriptJivo.setAttribute("async", true);
      document.head.appendChild(scriptJivo);
    },
    async getNotifications(sessao) {
      var thisCall = this;

      try {
        if (!sessao.usuario || !sessao.usuario._id) {
          return;
        }

        let resultApiNotification = await apiNotification.get(
          "/notification/token/" + sessao.usuario._id
        );

        if (
          resultApiNotification.status == 200 &&
          resultApiNotification.data &&
          resultApiNotification.data.result.length > 0
        ) {
          showSuccessNotification(
            "Novo plano",
            "Seu plano foi cadastrado! Aproveite!",
            20000
          );
        }
      } catch (err) {
        console.log(err);
      }

      setTimeout(() => {
        thisCall.getNotifications(sessao);
      }, 20000);
    },
  },
  mounted() {
    var thisCall = this;

    try {
      localStorage.setItem("debug", "");
    } catch (e) {
      console.log(e);
    }

    try {
      var darkMode = localStorage.getItem("darkMode", "false");

      if (darkMode == "true") {
        document.body.className += " body-dark";
      }
    } catch (e) {
      console.log(e);
    }

    if (this.$site == "Stream1x2") {
      document.body.className += " siteStream1x2";
    } else if (
      this.$site == "7live" &&
      this.$route.name == "home" &&
      this.$route.name == "agenda" &&
      this.$route.name == "meus-dados"
    ) {
      document.body.className += " site7live";
    }

    if (
      (this.$route.name == "home" || this.$route.name == "login") &&
      this.$site == "Stream1x2"
    ) {
      let script1 = document.createElement("script");
      script1.setAttribute("type", "text/javascript");
      script1.setAttribute("src", "/assets/js/chat-stream.js");
      script1.setAttribute("async", true);
      //document.head.appendChild(script1);

      let script2 = document.createElement("script");
      script2.setAttribute("type", "text/javascript");
      script2.setAttribute(
        "src",
        "https://d335luupugsy2.cloudfront.net/js/loader-scripts/694bf8c2-1824-41f4-9c53-a563029a1855-loader.js"
      );
      script2.setAttribute("async", true);
      //document.head.appendChild(script2);
    }

    var indieKeySorteio = localStorage.getItem("ckd");

    if (indieKeySorteio !== null) {
      setTimeout(async function () {
        //* Carrega os dados
        const apiRequest = await api.get("/sessao/session");

        //* Atualiza o cache local
        if (apiRequest.data.erro == false) {
          localStorage.setItem("ckdCch", JSON.stringify(apiRequest.data.item));

          try {
            if (thisCall.isHideHeader() == true) {
              if (thisCall.$site == "Weddbets" || thisCall.$site == "Bll") {
                //* Call notifications
                thisCall.getNotifications(apiRequest.data.item);
              }
            }
          } catch (errNotification) {
            console.error(errNotification);
          }
        } else {
          localStorage.removeItem("ckd");
          localStorage.removeItem("ckdCch");

          if (thisCall.$route.name !== "login") {
            this.$router.go({ name: "login" });
          }
        }
      }, 3000);

      //* Verifica se esta na pagina de login
      if (this.$route.name == "login") {
        this.$router.push({ name: "home" });
      }

      if (
        this.$route.name !== "sofascore" &&
        this.$route.name !== "view" &&
        this.$route.name !== "view2" &&
        this.$route.name !== "view3" &&
        this.$route.name !== "transmit" &&
        this.$route.name !== "transmit-remote" &&
        this.$route.name !== "eventos" &&
        this.$route.name !== "usuarios" &&
        this.$route.name !== "sessoes" &&
        this.$route.name !== "meus-dados"
      ) {
        if (this.$sitePrincipal == "Weddbets") {
          let scriptJivo = document.createElement("script");
          scriptJivo.setAttribute(
            "src",
            "//code.jivosite.com/widget/dI315sCDOQ"
          );

          scriptJivo.setAttribute("async", true);
          document.head.appendChild(scriptJivo);
        } else if (this.$site == "7live" && !this.isEscondeChat()) {
          let scriptJivo = document.createElement("script");
          scriptJivo.setAttribute(
            "src",
            "//code.jivosite.com/widget/Anzebp6DmL"
          );
          scriptJivo.setAttribute("async", true);
          document.head.appendChild(scriptJivo);
        } else if (this.$sitePrincipal == "Bll") {
          //this.chatTank();
          this.chatWbot();
        } else if (this.$site == "Stream1x2") {
          let scriptJivo = document.createElement("script");
          scriptJivo.setAttribute(
            "src",
            "//code.jivosite.com/widget/kRZ4TKBriT"
          );
          scriptJivo.setAttribute("async", true);
          document.head.appendChild(scriptJivo);
        }
      }

      let scriptFlash = document.createElement("script");
      scriptFlash.setAttribute("src", "/assets/js/utils.js");
      scriptFlash.setAttribute("async", true);
      document.head.appendChild(scriptFlash);

      //* Define que o usuario esta autenticado
      this.$set(this.autenticado, "status", true);
      this.$set(this.autenticado, "key", indieKeySorteio);
    } else {
      //* Verifica se esta na pagina de login
      if (
        this.$route.name !== "login" &&
        this.$route.name !== "recuperar-senha" &&
        this.$route.name !== "cadastro" &&
        this.$route.name !== "front-promocao"
      ) {
        this.$router.push({ name: "login" });
      }

      if (this.$route.name == "login" && this.$site == "Weddbets") {
        let scriptJivo = document.createElement("script");
        scriptJivo.setAttribute("src", "//code.jivosite.com/widget/dI315sCDOQ");
        scriptJivo.setAttribute("async", true);
        document.head.appendChild(scriptJivo);
      }

      if (this.$route.name == "login" && this.$site == "Stream1x2") {
        let scriptJivo = document.createElement("script");
        scriptJivo.setAttribute("src", "//code.jivosite.com/widget/ZVdJCuwyZb");
        scriptJivo.setAttribute("async", true);
        //document.head.appendChild(scriptJivo);
      }

      if (this.$route.name == "login" && this.$site == "7live") {
        let scriptJivo = document.createElement("script");
        scriptJivo.setAttribute("src", "//code.jivosite.com/widget/Anzebp6DmL");
        scriptJivo.setAttribute("async", true);
        document.head.appendChild(scriptJivo);
      }

      if (this.$route.name == "login" && this.$site == "Bll") {
        //this.chatTank();
        this.chatWbot();
      }
    }
  },
};
</script>

<style>
.site7live {
  font-family: "Oswald", sans-serif !important;
}

.appHeader {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  margin-bottom: 20px;
}

.noMarginTop {
  margin-top: 0px !important;
}

.appHeaderAdminWeddbets {
  margin-top: 62px !important;
  padding-top: 0;
}

.adminHeaderConteudo {
  padding-top: 16px;
}

.adminHeaderConteudo > * {
  box-sizing: border-box;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-top: 0 !important;
  max-width: 1180px !important;
  width: calc(100% - 32px) !important;
}

@media (max-width: 767px) {
  .adminHeaderConteudo > * {
    width: calc(100% - 12px) !important;
  }
}

.appHeaderClienteNovo {
  margin-top: 64px !important;
  padding-top: 0;
}

.clienteHeaderConteudo {
  padding-top: 0;
}

.clienteHeaderConteudo > * {
  margin-top: 0 !important;
}

.noPadding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.siteStream1x2 {
  background-color: #f5f5f5;
}

.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.cursor-pointer {
  cursor: pointer;
}

.body-dark {
  --dark-bg: #111518;
  --dark-surface: #1a2024;
  --dark-surface-alt: #20272c;
  --dark-surface-raised: #283137;
  --dark-border: #39434a;
  --dark-border-soft: #2c353b;
  --dark-text: #e5eaed;
  --dark-text-soft: #c6d0d5;
  --dark-muted: #98a4ab;
  --dark-green: #50b982;
  --dark-gold: #e0ad58;
  color-scheme: dark !important;
  background-color: var(--dark-bg) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

.body-dark #app,
.body-dark .adminHeaderConteudo,
.body-dark .clienteHeaderConteudo {
  color: var(--dark-text) !important;
}

.body-dark .adminHeader,
.body-dark .clienteHeader {
  background: #20262b !important;
  border-color: #46525a !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.34) !important;
}

.body-dark .adminHeaderItem,
.body-dark .adminHeaderSair,
.body-dark .clienteHeaderItem {
  color: #cdd5d9 !important;
}

.body-dark .adminHeaderItem:hover,
.body-dark .adminHeaderSair:hover,
.body-dark .adminHeaderItem.router-link-active,
.body-dark .clienteHeaderItem:hover,
.body-dark .clienteHeaderItem.router-link-active {
  background: #303940 !important;
  color: #ffffff !important;
}

.body-dark .adminHeaderItem.router-link-active {
  border-bottom-color: var(--dark-gold) !important;
}

.body-dark .homeEventosFerramentas,
.body-dark .homeEventosOrdenacao {
  border-color: var(--dark-border) !important;
}

.body-dark .homeEventosBusca i,
.body-dark .homeEventosOrdenacao > i {
  color: var(--dark-muted) !important;
}

.body-dark .homeCompeticoesFiltro,
.body-dark .homeCompeticoesCabecalho,
.body-dark .homeCompeticoesBusca,
.body-dark .homeCompeticaoItem {
  border-color: var(--dark-border) !important;
}

.body-dark .homeCompeticoesFiltro,
.body-dark .homeCompeticoesAbrir,
.body-dark .homeCompeticoesReabrir,
.body-dark .clienteCompeticoesAbrir,
.body-dark .clienteCompeticoesReabrir {
  background: var(--dark-surface) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .homeCompeticoesAbrir small,
.body-dark .homeCompeticoesReabrir small,
.body-dark .clienteCompeticoesAbrir small,
.body-dark .clienteCompeticoesReabrir small {
  background: var(--dark-surface-alt) !important;
  color: var(--dark-muted) !important;
}

.body-dark .homeCompeticoesRecolher,
.body-dark .clienteFiltroCompeticoes > header > .clienteCompeticoesRecolher {
  color: var(--dark-muted) !important;
}

.body-dark .homeCompeticoesBusca input {
  background: var(--dark-surface-raised) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

.body-dark .homeCompeticaoItem:hover {
  background: var(--dark-surface-raised) !important;
}

.body-dark .homeCompeticaoItem small {
  background: var(--dark-surface-alt) !important;
  color: var(--dark-muted) !important;
}

.body-dark .form-control,
.body-dark .custom-select,
.body-dark .autocomplete-input,
.body-dark input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]),
.body-dark textarea,
.body-dark select {
  background-color: var(--dark-surface-alt) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

.body-dark input::placeholder,
.body-dark textarea::placeholder {
  color: #7f8b92 !important;
  opacity: 1;
}

.body-dark input[type="checkbox"],
.body-dark input[type="radio"] {
  accent-color: var(--dark-green);
}

.body-dark .input-group-text,
.body-dark .dropdown-menu {
  background: var(--dark-surface-raised) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .dropdown-item {
  color: var(--dark-text-soft) !important;
}

.body-dark .dropdown-item:hover,
.body-dark .dropdown-item:focus {
  background: #333d44 !important;
  color: #ffffff !important;
}

.body-dark .table {
  color: var(--dark-text-soft) !important;
}

.body-dark .table td,
.body-dark .table th {
  border-color: var(--dark-border-soft) !important;
}

.body-dark .table-striped tbody tr:nth-of-type(odd) {
  background: rgba(255, 255, 255, 0.025) !important;
}

.body-dark .card,
.body-dark .jumbotron,
.body-dark .alert-light {
  background: var(--dark-surface) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

.body-dark .modal-content {
  color-scheme: dark !important;
  background-color: var(--dark-surface) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

.body-dark .modal-header,
.body-dark .modal-footer {
  background: var(--dark-surface-alt) !important;
  border-color: var(--dark-border) !important;
}

.body-dark .modal-title,
.body-dark .close {
  color: var(--dark-text) !important;
  text-shadow: none !important;
}

.body-dark .list-group-item {
  background-color: var(--dark-surface) !important;
  color: var(--dark-text) !important;
  border-color: var(--dark-border-soft) !important;
}

.body-dark .list-group-item-action:hover,
.body-dark .list-group-item-action:focus {
  background-color: var(--dark-surface-raised) !important;
  color: #ffffff !important;
}

.body-dark .btn-light,
.body-dark .btn-outline-dark,
.body-dark .btn-outline-secondary {
  background: var(--dark-surface-alt) !important;
  border-color: #64717a !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .btn-light:hover,
.body-dark .btn-outline-dark:hover,
.body-dark .btn-outline-secondary:hover {
  background: #343f46 !important;
  color: #ffffff !important;
}

.body-dark hr {
  border-color: var(--dark-border-soft) !important;
}

.body-dark .tituloJogos {
  color: var(--dark-text) !important;
}

/* Home e favoritos do novo layout */
.body-dark .clienteHome {
  color: var(--dark-text) !important;
}

.body-dark .clienteHomeCabecalho,
.body-dark .clienteHomeAbas {
  border-color: var(--dark-border) !important;
}

.body-dark .clienteHomeCabecalho h1,
.body-dark .clienteHomeAbas button.ativo,
.body-dark .clienteCompeticao > header strong,
.body-dark .clienteEvento time strong,
.body-dark .clienteLateralBloco > header > span,
.body-dark .clienteFiltroCompeticoes > header > div > span,
.body-dark .clientePlanoDetalhe strong,
.body-dark .clienteHomeEstado strong {
  color: var(--dark-text) !important;
}

.body-dark .clienteHomeEyebrow,
.body-dark .clienteEvento time span,
.body-dark .clienteContaLink,
.body-dark .clienteFiltroCompeticoes > header > button {
  color: var(--dark-green) !important;
}

.body-dark .clienteFiltroCompeticoes > header > .clienteCompeticoesFechar {
  color: var(--dark-muted) !important;
}

.body-dark .clienteHomeAtualizacao,
.body-dark .clienteHomeOrdenacao > i,
.body-dark .clienteHomeAbas button,
.body-dark .clienteCompeticao > header span,
.body-dark .clienteEvento time small,
.body-dark .clientePlanoDetalhe span,
.body-dark .clienteFiltroCompeticoes > header > div > small,
.body-dark .clienteCompeticoesVazio,
.body-dark .clienteHomeEstado {
  color: var(--dark-muted) !important;
}

.body-dark .clienteHomeBusca,
.body-dark .clienteHomeOrdenacao,
.body-dark .clienteHomeAtualizar {
  background: var(--dark-surface-alt) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .clienteHomeBusca input,
.body-dark .clienteHomeOrdenacao select {
  background: transparent !important;
  color: var(--dark-text) !important;
}

.body-dark .clienteHomeAtualizar:hover,
.body-dark .clienteHomeAbas button:hover {
  background: var(--dark-surface-raised) !important;
  color: #ffffff !important;
}

.body-dark .clienteCompeticao,
.body-dark .clienteLateralBloco,
.body-dark .clienteHomeEstado {
  background: var(--dark-surface) !important;
  border-color: var(--dark-border) !important;
}

.body-dark .clienteCompeticao > header,
.body-dark .clienteCompeticoesBusca {
  background: var(--dark-surface-alt) !important;
  border-color: var(--dark-border) !important;
}

.body-dark .clienteEvento,
.body-dark .clienteLateralBloco > header,
.body-dark .clienteContaLink,
.body-dark .clienteCompeticoesOpcoes label.clienteCompeticaoOpcao,
.body-dark .clienteFiltroCompeticoes > footer {
  border-color: var(--dark-border-soft) !important;
}

.body-dark .clienteEventoNome,
.body-dark .clienteCompeticoesBusca input,
.body-dark .clienteCompeticoesOpcoes label.clienteCompeticaoOpcao.ativo {
  color: var(--dark-text-soft) !important;
}

.body-dark .clienteEvento:hover,
.body-dark .clienteCompeticoesOpcoes label.clienteCompeticaoOpcao:hover,
.body-dark .clienteContaLink:hover {
  background: #21292e !important;
}

.body-dark .clienteEventoAssistirLimpo {
  background: var(--dark-surface-raised) !important;
  border-color: #71808a !important;
  color: var(--dark-text) !important;
}

.body-dark .clienteEventoAssistir:disabled {
  background: #22292e !important;
  border-color: var(--dark-border) !important;
  color: #6f7a81 !important;
}

.body-dark .clienteLateralBloco > header > strong {
  background: #193528 !important;
  color: #75d2a2 !important;
}

.body-dark .clienteLateralBloco > header > strong.inativo {
  background: #3a2325 !important;
  color: #e49898 !important;
}

.body-dark .clienteCompeticoesOpcoes label.clienteCompeticaoOpcao {
  color: var(--dark-muted) !important;
}

.body-dark .clienteCompeticoesOpcoes label > small,
.body-dark .clienteFiltroCompeticoes > footer {
  background: #232b30 !important;
  color: #aab4ba !important;
}

/* Páginas operacionais */
.body-dark .eventosCabecalho,
.body-dark .administracaoCabecalho,
.body-dark .usuariosCabecalho,
.body-dark .meusDadosCabecalho,
.body-dark .sessoesCabecalho {
  border-color: var(--dark-border) !important;
}

.body-dark .eventosCabecalho h1,
.body-dark .administracaoCabecalho h1,
.body-dark .usuariosCabecalho h1,
.body-dark .meusDadosCabecalho h1,
.body-dark .sessoesCabecalho h1,
.body-dark .eventosCabecalhoResumo span,
.body-dark .usuariosTotal strong {
  color: var(--dark-text) !important;
}

.body-dark .eventosEyebrow,
.body-dark .administracaoCabecalho p,
.body-dark .usuariosEyebrow,
.body-dark .meusDadosCabecalho p,
.body-dark .sessoesEyebrow {
  color: var(--dark-green) !important;
}

.body-dark .eventosDescricao,
.body-dark .administracaoCabecalho span,
.body-dark .usuariosCabecalho p:not(.usuariosEyebrow),
.body-dark .meusDadosCabecalho span,
.body-dark .sessoesAtualizacao,
.body-dark .eventosCabecalhoResumo small,
.body-dark .usuariosTotal small {
  color: var(--dark-muted) !important;
}

.body-dark .eventosControles,
.body-dark .usuariosFerramentas,
.body-dark .sessoesPainelConteudo .d-flex.justify-content-between,
.body-dark .sessoesPainelConteudo .d-flex.justify-content-start,
.body-dark .sessoesPainelConteudo .d-flex.justify-content-center {
  background: var(--dark-surface) !important;
  border-color: var(--dark-border) !important;
}

.body-dark .eventosComando,
.body-dark .eventosModo button,
.body-dark .eventosSelecionados,
.body-dark .usuariosSecundario {
  background: var(--dark-surface-alt) !important;
  border-color: #5b6871 !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .eventosComandoPrincipal,
.body-dark .usuariosNovo {
  background: #1769c2 !important;
  border-color: #277cd9 !important;
  color: #ffffff !important;
}

.body-dark .eventosComandoAbas,
.body-dark .eventosComandoAbasAtivo {
  background: #1c3831 !important;
  border-color: #4c947f !important;
  color: #8ed6bd !important;
}

.body-dark .eventosModo button.ativo {
  background: #39434a !important;
  border-color: #59656d !important;
  color: #ffffff !important;
}

.body-dark .eventosPesquisa,
.body-dark .eventosAgrupamento,
.body-dark .usuariosFiltro,
.body-dark .usuariosPesquisa,
.body-dark .meusDadosCabecalho > small {
  background: var(--dark-surface-alt) !important;
  border-color: var(--dark-border) !important;
}

.body-dark .eventosPesquisa input,
.body-dark .eventosAgrupamento .form-control,
.body-dark .usuariosPesquisa input,
.body-dark .usuariosFiltro .form-control {
  background: transparent !important;
  color: var(--dark-text) !important;
}

.body-dark .eventosAgrupamento > span,
.body-dark .usuariosFiltro > span,
.body-dark .meusDadosCabecalho > small {
  color: var(--dark-muted) !important;
}

.body-dark .eventosAbas,
.body-dark .administracaoAbas,
.body-dark .usuariosTipos,
.body-dark .sessoesAbas,
.body-dark .editUsuarioAbas,
.body-dark .editEventoAbas {
  border-color: var(--dark-border) !important;
}

.body-dark .eventosAbas button,
.body-dark .administracaoAbas button,
.body-dark .usuariosTipos button,
.body-dark .sessoesAbas button,
.body-dark .editUsuarioAbas button,
.body-dark .editEventoAba {
  background: transparent !important;
  color: var(--dark-muted) !important;
}

.body-dark .eventosAbas button:hover,
.body-dark .administracaoAbas button:hover,
.body-dark .usuariosTipos button:hover,
.body-dark .sessoesAbas button:hover,
.body-dark .editUsuarioAbas button:hover,
.body-dark .editEventoAba:hover {
  background: var(--dark-surface-alt) !important;
  color: #ffffff !important;
}

.body-dark .eventosAbas button.ativo,
.body-dark .administracaoAbas button.ativo,
.body-dark .usuariosTipos button.ativo,
.body-dark .sessoesAbas button.ativo,
.body-dark .editUsuarioAbas button.ativo,
.body-dark .editEventoAba.active {
  color: var(--dark-text) !important;
}

.body-dark .eventosAbas button.ativo,
.body-dark .sessoesAbas button.ativo {
  border-bottom-color: var(--dark-green) !important;
}

.body-dark .administracaoAbas button.ativo,
.body-dark .usuariosTipos button.ativo,
.body-dark .editUsuarioAbas button.ativo,
.body-dark .editEventoAba.active {
  border-bottom-color: var(--dark-gold) !important;
}

.body-dark .eventosPainel .tituloJogos,
.body-dark .meusDadosSecaoTitulo,
.body-dark .editEventoSecaoTitulo {
  border-color: var(--dark-border) !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .eventosGrupoTitulo {
  background: var(--dark-surface-raised) !important;
  border-left-color: var(--dark-green) !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .eventosCompactos {
  color: var(--dark-text) !important;
}

.body-dark .eventoCompactoAviso,
.body-dark .eventoCompactoGrupo {
  background: var(--dark-surface-raised) !important;
  border-color: var(--dark-green) !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .eventoCompactoLinha {
  background: var(--dark-surface) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

.body-dark .eventoCompactoLinhaSelecionada {
  background: #1b2b38 !important;
  box-shadow: inset 3px 0 #4b9ee8 !important;
}

.body-dark .eventoCompactoTitulo time,
.body-dark .eventoCompactoTitulo strong {
  color: var(--dark-text-soft) !important;
}

.body-dark .eventoCompactoMeta,
.body-dark .eventoCompactoCanais span {
  color: var(--dark-muted) !important;
}

.body-dark .eventoCompactoMeta > span:not(:last-child)::after,
.body-dark .eventoCompactoCanais {
  border-color: var(--dark-border-soft) !important;
  color: #66737b !important;
}

.body-dark .eventoCompactoSelecao button,
.body-dark .eventoCompactoTag,
.body-dark .eventoCompactoBotaoNeutro,
.body-dark .eventoCompactoMais,
.body-dark .eventoCompactoCanais button {
  background: var(--dark-surface-alt) !important;
  border-color: #59666e !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .eventoCompactoTagAtiva {
  background: #384249 !important;
  border-color: #65727a !important;
  color: #ffffff !important;
}

.body-dark .eventoCompactoBotaoPrincipal {
  background: #1769c2 !important;
  border-color: #277cd9 !important;
  color: #ffffff !important;
}

.body-dark .eventoCompactoMenuLista,
.body-dark .eventoCompactoMenuLista button {
  background: var(--dark-surface-raised) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .eventoCompactoMenuLista button:hover {
  background: #354047 !important;
  color: #ffffff !important;
}

/* Sessões */
.body-dark .sessoesPainel {
  color: var(--dark-text) !important;
}

.body-dark .sessoesAtualizar,
.body-dark .sessoesMetrica,
.body-dark .sessoesWidget,
.body-dark .sessoesSubabaCorpo {
  background: var(--dark-surface) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

.body-dark .sessoesAtualizar:hover,
.body-dark .sessoesRankingItem:hover {
  background: var(--dark-surface-raised) !important;
  color: #ffffff !important;
}

.body-dark .sessoesMetricaIconeVerde {
  background: #19372a !important;
  color: #72d2a0 !important;
}

.body-dark .sessoesMetricaIconeAzul {
  background: #1c3040 !important;
  color: #79b4db !important;
}

.body-dark .sessoesMetricaIconeAmarelo {
  background: #3a3020 !important;
  color: #e4bd62 !important;
}

.body-dark .sessoesMetricaIconeCinza {
  background: #30383d !important;
  color: #bdc7cc !important;
}

.body-dark .sessoesMetricaIconeVioleta {
  background: #332a3e !important;
  color: #c0a1df !important;
}

.body-dark .sessoesMetrica div span,
.body-dark .sessoesRankingTexto small,
.body-dark .sessoesServidorNome small,
.body-dark .sessoesWidgetRodape span,
.body-dark .sessoesVazio {
  color: var(--dark-muted) !important;
}

.body-dark .sessoesWidgetCabecalho,
.body-dark .sessoesRankingItem,
.body-dark .sessoesServidorItem,
.body-dark .sessoesSubabaCabecalho,
.body-dark .sessoesPainelConteudo .sessoesSubabaFiltros,
.body-dark .sessoesPainelConteudo .sessoesSubabaLinha {
  border-color: var(--dark-border-soft) !important;
}

.body-dark .sessoesWidgetCabecalho h2,
.body-dark .sessoesSubabaCabecalho h2,
.body-dark .sessoesRankingTexto strong,
.body-dark .sessoesRankingValor,
.body-dark .sessoesServidorNome strong,
.body-dark .sessoesServidorLinha > strong {
  color: var(--dark-text-soft) !important;
}

.body-dark .sessoesWidgetCabecalho > strong,
.body-dark .sessoesSubabaCabecalho > strong,
.body-dark .sessoesWidgetRodape {
  background: var(--dark-surface-alt) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .sessoesRankingBarra,
.body-dark .sessoesServidorBarra {
  background: #303a40 !important;
}

.body-dark .sessoesPainelConteudo .rowLista {
  border-color: var(--dark-border) !important;
}

.body-dark .sessoesPainelConteudo .sessoesSubabaFiltros,
.body-dark .sessoesPainelConteudo .sessoesSubabaTabela .list-group-item-dark {
  background: var(--dark-surface-alt) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-muted) !important;
}

.body-dark .sessoesSubabaLinha h5 {
  color: var(--dark-text-soft) !important;
}

.body-dark .sessoesSubabaLinha h6,
.body-dark .sessoesSubabaLinha small,
.body-dark .sessoesSubabaVazio {
  color: var(--dark-muted) !important;
}

.body-dark .sessoesPainelConteudo .sessoesSubabaLinha:hover {
  background: var(--dark-surface-raised) !important;
}

/* Administração, usuários e meus dados */
.body-dark .usuarioLinha {
  background: var(--dark-surface) !important;
  border-color: var(--dark-border-soft) !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .usuarioLinha:hover {
  background: var(--dark-surface-raised) !important;
}

.body-dark .usuarioAvatar,
.body-dark .editUsuarioAvatar {
  background: #30393f !important;
  border-color: #4a565e !important;
  color: #d8e0e4 !important;
}

.body-dark .usuarioIdentidade small,
.body-dark .usuarioDatas span,
.body-dark .usuarioDatas small,
.body-dark .usuarioAbrir,
.body-dark .usuariosVazio,
.body-dark .editUsuarioIdentificacao small,
.body-dark .editUsuarioConteudo .col-form-label {
  color: var(--dark-muted) !important;
}

.body-dark .usuarioSite,
.body-dark .usuarioTipo {
  background: var(--dark-surface-raised) !important;
  border-color: #4a555c !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .meusDadosPagina > .editUsuarioDialog .modal-content {
  background: transparent !important;
  border-color: transparent !important;
}

.body-dark .meusDadosPagina > .editUsuarioDialog .modal-footer {
  background: var(--dark-surface) !important;
  border-color: var(--dark-border) !important;
}

.body-dark .meusDadosPagina .meusDadosPreferenciaItem {
  background: transparent !important;
}

.body-dark .meusDadosPagina .meusDadosLinha {
  border-color: var(--dark-border) !important;
}

.body-dark .editUsuarioDialog .modal-header,
.body-dark .editEventoDialog .modal-header {
  background: var(--dark-surface-alt) !important;
  border-bottom-color: var(--dark-border) !important;
  border-top-color: var(--dark-gold) !important;
}

.body-dark .editUsuarioDialog .modal-title,
.body-dark .editEventoDialog .modal-title,
.body-dark .editUsuarioIdentificacao strong,
.body-dark .editEventoSourceIdentificacao strong {
  color: var(--dark-text) !important;
}

.body-dark .editUsuarioIndicacaoSelecionada,
.body-dark .editEventoSourceItem {
  background: var(--dark-surface-alt) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .editUsuarioIndicacaoSelecionada:hover,
.body-dark .editEventoSourceItem.principal {
  background: var(--dark-surface-raised) !important;
}

.body-dark .editEventoSourcesLista,
.body-dark .editEventoSourceItem + .editEventoSourceItem {
  border-color: var(--dark-border) !important;
}

.body-dark .editEventoFormulario .col-form-label,
.body-dark .editEventoDataHora h6,
.body-dark .editEventoSourcePrincipal,
.body-dark .editEventoSourceDispositivo span,
.body-dark .editEventoSourceDispositivo small,
.body-dark .editEventoSourcesVazio {
  color: var(--dark-muted) !important;
}

.favorito {
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.favorito i {
  font-size: 18px;
  color: #ccc;
}

.favorito:hover i {
  color: #ffc107;
}

.favorito.ativo i {
  color: #ffc107;
}

/* notification */
.notification-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  max-width: 90%;
  z-index: 9999;
}

.notification {
  position: relative;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.3s ease;
  text-align: center;
  padding: 25px;
}

.notification.show {
  opacity: 1;
  transform: scale(1);
}

.notification.success {
  border-left: 5px solid #28a745;
}

.notification .progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.7);
  width: 100%;
  transition: width linear;
}

.notification-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 15px;
  display: block;
}
</style>
